import { render, staticRenderFns } from "./lottery_page_lose.vue?vue&type=template&id=00dda7de&scoped=true"
import script from "./lottery_page_lose.vue?vue&type=script&lang=ts"
export * from "./lottery_page_lose.vue?vue&type=script&lang=ts"
import style0 from "./lottery_page_lose.vue?vue&type=style&index=0&id=00dda7de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dda7de",
  null
  
)

export default component.exports